import { render, staticRenderFns } from "./handleNode.vue?vue&type=template&id=b1a139a8&scoped=true"
import script from "./handleNode.vue?vue&type=script&lang=js"
export * from "./handleNode.vue?vue&type=script&lang=js"
import style0 from "./handleNode.vue?vue&type=style&index=0&id=b1a139a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a139a8",
  null
  
)

export default component.exports